/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApplicantsResponse,
  GetClientCohortsParams,
  GetCohortsResponse,
  HTTPValidationError,
  RecentUpdateRequest,
  UpdateRecentUpdate200,
} from './platformapi.schemas';

import getApplicantsMutator from '../custom-axios-instance';
import getClientCohortsMutator from '../custom-axios-instance';
import updateRecentUpdateMutator from '../custom-axios-instance';

/**
 * Get a list of professionals who have applied to work with the corporate client.
 * @summary Get Applicants
 */
export const getApplicants = (cohortId: number, signal?: AbortSignal) => {
  return getApplicantsMutator<GetApplicantsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`,
    method: 'GET',
    signal,
  });
};

export const getGetApplicantsQueryKey = (cohortId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/corporate-admins/applications/${cohortId}`] as const;
};

export const getGetApplicantsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApplicantsQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicants>>> = ({ signal }) =>
    getApplicants(cohortId, signal);

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApplicants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApplicantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicants>>>;
export type GetApplicantsQueryError = void | HTTPValidationError;

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Applicants
 */

export function useGetApplicants<
  TData = Awaited<ReturnType<typeof getApplicants>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApplicantsQueryOptions(cohortId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a list of cohorts associated with the corporate client. Corporate admins are scoped to their
own client; platform admins must pass corporate_client_id to choose a client.
 * @summary Get Client Cohorts
 */
export const getClientCohorts = (params?: GetClientCohortsParams, signal?: AbortSignal) => {
  return getClientCohortsMutator<GetCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetClientCohortsQueryKey = (params?: GetClientCohortsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/corporate-admins/cohorts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetClientCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetClientCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientCohortsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientCohorts>>> = ({ signal }) =>
    getClientCohorts(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientCohorts>>>;
export type GetClientCohortsQueryError = void | HTTPValidationError;

export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetClientCohortsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetClientCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetClientCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Client Cohorts
 */

export function useGetClientCohorts<
  TData = Awaited<ReturnType<typeof getClientCohorts>>,
  TError = void | HTTPValidationError,
>(
  params?: GetClientCohortsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientCohortsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create/update the admin-authored 'recent update' note for a participant in a cohort.
Platform-admin only - corporate client admins have read-only access to these notes, and are
rejected here even if they call this endpoint directly.
 * @summary Update Recent Update
 */
export const updateRecentUpdate = (
  cohortId: number,
  userId: number,
  recentUpdateRequest: RecentUpdateRequest,
  signal?: AbortSignal,
) => {
  return updateRecentUpdateMutator<UpdateRecentUpdate200>({
    url: `${import.meta.env['VITE_API_HOST']}/corporate-admins/recent-update/${cohortId}/${userId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: recentUpdateRequest,
    signal,
  });
};

export const getUpdateRecentUpdateMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRecentUpdate>>,
    TError,
    { cohortId: number; userId: number; data: RecentUpdateRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRecentUpdate>>,
  TError,
  { cohortId: number; userId: number; data: RecentUpdateRequest },
  TContext
> => {
  const mutationKey = ['updateRecentUpdate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRecentUpdate>>,
    { cohortId: number; userId: number; data: RecentUpdateRequest }
  > = (props) => {
    const { cohortId, userId, data } = props ?? {};

    return updateRecentUpdate(cohortId, userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRecentUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRecentUpdate>>
>;
export type UpdateRecentUpdateMutationBody = RecentUpdateRequest;
export type UpdateRecentUpdateMutationError = void | HTTPValidationError;

/**
 * @summary Update Recent Update
 */
export const useUpdateRecentUpdate = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRecentUpdate>>,
      TError,
      { cohortId: number; userId: number; data: RecentUpdateRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRecentUpdate>>,
  TError,
  { cohortId: number; userId: number; data: RecentUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateRecentUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
